<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Detalhes usuário"
      Pagina="Detalhes"
      [TemPaginaPai] = true
      LinkPaginaPai="/auth/usuario"
      PaginaPai="Usuários"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
        <div class="card" style="min-height: 500px">
          <div class="card-body" >
            <div class="row">
              <div class="col-md-3"  style="border-right: 1px #4973cf solid;min-height: 500px; padding-right: 50px; ">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title text-blue">Opções</h3>
                    <div class="card-tools">
                      <button type="button" class="btn btn-tool" data-card-widget="collapse">
                        <i class="fa fa-minus text-blue"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <ul class="nav nav-pills flex-column">
                      <li *ngIf="token?.seguranca == 'Admin' " [ngClass]="showAlterarDados ? 'active': ''" class="nav-item">
                        <a (click)="mostrarAlterarDados()" [ngClass]="showAlterarDados ? 'activeLink': ''" class="nav-link">
                          <i [ngClass]="showAlterarDados ? 'activeLink': ''" class="fa fa-edit text-blue" style="margin-right: 8px"></i>  Alterar dados
                        </a>
                      </li>
                      <li *ngIf="token?.email == usuario.email " [ngClass]="showAlterarSenha ? 'active': ''"  class="nav-item">
                        <a (click)="mostrarAlterarSenha()" [ngClass]="showAlterarSenha ? 'activeLink': ''" class="nav-link">
                          <i [ngClass]="showAlterarSenha ? 'activeLink': ''" class="fa fa-user-secret text-blue" style="margin-right: 8px"></i>  Alterar senha
                        </a>
                      </li>
                      <li *ngIf="tipo == 'Administrador' " [ngClass]="showDetalhesConta ? 'active': ''"  class="nav-item">
                        <a (click)="mostrarDetalhes()" [ngClass]="showDetalhesConta ? 'activeLink': ''" class="nav-link">
                          <i [ngClass]="showDetalhesConta ? 'activeLink': ''" class="fa fa-cogs text-blue" style="margin-right: 8px"></i>  Informações conta
                        </a>
                      </li>
                      <li *ngIf="token?.seguranca == 'Admin' && usuario.bloqueio" class="nav-item">
                        <a (click)="desbloquear()" class="nav-link">
                          <i class="fa fa-user-plus text-blue" style="margin-right: 8px"></i>  Desbloquear
                        </a>
                      </li>
                      <li *ngIf="token?.seguranca == 'Admin' && !usuario.ativo" class="nav-item">
                        <a (click)="ativar()" class="nav-link">
                          <i class="fa fa-user-plus text-blue" style="margin-right: 8px"></i>  Ativar
                        </a>
                      </li>
                      <li *ngIf="token?.seguranca == 'Admin' && usuario.ativo" class="nav-item">
                        <a (click)="desativar()" class="nav-link">
                          <i class="fa fa-minus text-blue" style="margin-right: 8px"></i>  Desativar
                        </a>
                      </li>
                      <li class="nav-item"  (click)="voltar()">
                        <a  class="nav-link">
                          <i class="fa fa-backward text-danger" style="margin-right: 8px"></i>  Voltar
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-12"><h2 class="text-blue">{{usuario.nome}}</h2></div>
                  <div class="col-md-12">Email: <b>{{usuario.email}}</b></div>
                  <div class="col-md-12">Tipo: <b>{{tipo}}</b></div>
                </div>
                <hr class="col-md-11">
                <div class="row"  *ngIf="showAlterarDados">
                  <form id="formAlterarDados" class="col-md-12" [formGroup]="formAlterarDados">
                    <div class="row" style="margin-top: 30px" >
                      <h4 class="col-md-12">Alterar dados</h4>

                      <div class="form-group col-md-6">
                        <label for="nome">Nome</label>
                        <input
                          type="text"
                          class="form-control"
                          formControlName="nome"
                          id="nome"
                        >
                      </div>
                      <div class="form-group col-md-6">
                        <label for="tipoUsuario">Tipo de usuário</label>
                        <ng-select [items]="tiposUsuario"
                                   bindLabel="descricao"
                                   bindValue="id"
                                   formControlName="tipoUsuario"
                                   [clearable]="false"
                                   id="tipoUsuario">
                        </ng-select>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-md-6"><button (click)="voltar()" class="btn btn-light col-md-4">Voltar</button></div>
                      <div class="col-md-6 text-right">

                        <button (click)="salvarAlteracoes()" class="btn btn-primary col-md-4">Salvar</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="row"  *ngIf="showAlterarSenha">
                  <form id="formAlterarSenha" class="col-md-12" [formGroup]="formAlterarSenha">
                    <div class="row" style="margin-top: 30px" >
                      <h4 class="col-md-12">Alterar senha</h4>
                      <div class="form-group col-md-12">
                        <label for="senhaAntiga">Senha Antiga</label>
                        <input
                          type="password"
                          class="form-control"
                          formControlName="senhaAntiga"
                          id="senhaAntiga"
                        >
                      </div>
                      <div class="form-group col-md-6">
                        <label for="senhaNova">Nova senha</label>
                        <input
                          type="password"
                          class="form-control"
                          formControlName="senhaNova"
                          id="senhaNova"
                        >
                      </div>
                      <div class="form-group col-md-6">
                        <label for="confirmacaoSenha">Confirmação</label>
                        <input
                          type="password"
                          class="form-control"
                          formControlName="confirmacaoSenha"
                          id="confirmacaoSenha"
                        >
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-md-6"><button (click)="voltar()" class="btn btn-light col-md-4">Voltar</button></div>
                      <div class="col-md-6 text-right">

                        <button (click)="alterarSenha()" class="btn btn-primary col-md-4">Salvar</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="row" *ngIf="showDetalhesConta">
                  <app-meu-plano></app-meu-plano>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
